import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var View360Icon = function View360Icon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "View360Icon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.35 3.016c.26-.261.614-.408.983-.408h1.334A1.39 1.39 0 0 1 10.058 4a.725.725 0 0 1-1.447.058H7.39v1.217h1.276a1.39 1.39 0 0 1 1.391 1.392V8a1.39 1.39 0 0 1-1.391 1.392H7.333A1.39 1.39 0 0 1 5.942 8V4c0-.37.146-.723.407-.984m1.042 3.709v1.217h1.216V6.725zM1.275 3.333c0-.4.325-.725.725-.725h1.667a1.725 1.725 0 0 1 1.725 1.725V5c0 .36-.113.71-.32 1 .207.29.32.64.32 1v.667a1.725 1.725 0 0 1-1.725 1.725H2a.725.725 0 0 1 0-1.45h1.667a.275.275 0 0 0 .275-.275V7a.275.275 0 0 0-.275-.275h-1a.725.725 0 1 1 0-1.45h1A.275.275 0 0 0 3.942 5v-.667a.275.275 0 0 0-.275-.275H2a.725.725 0 0 1-.725-.725M11.211 3.211a2.058 2.058 0 0 1 3.514 1.456v2.666a2.058 2.058 0 0 1-4.117 0V4.667c0-.546.217-1.07.603-1.456m1.456.847a.61.61 0 0 0-.609.609v2.666a.608.608 0 0 0 1.217 0V4.667a.61.61 0 0 0-.608-.609M2.725 10.66a.725.725 0 0 0-1.45.007c0 .593.361 1.043.748 1.348.394.31.92.559 1.505.754 1.178.392 2.759.623 4.472.623s3.294-.23 4.472-.623c.585-.195 1.11-.444 1.505-.754.386-.305.748-.755.748-1.348a.725.725 0 0 0-1.45-.008v-.001.009-.008c-.005.017-.037.092-.195.217-.213.167-.566.35-1.067.517-.994.331-2.413.549-4.013.549s-3.02-.218-4.013-.549c-.501-.167-.854-.35-1.067-.517-.159-.125-.19-.2-.195-.217m0-.002-.001-.002z",
      clipRule: "evenodd"
    })
  }));
};

export { View360Icon };
